import React from "react";
import { Download } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";

/**
 * "Scarica" button for SINGLE (ungrouped) cards — the equivalent of the
 * group's "ZIP gruppo": one click downloads the original file straight
 * from Dropbox through our backend stream, no need to open the Dropbox
 * folder by hand.
 *
 * Plain <a> on purpose: auth is cookie-based (same-origin), so the
 * browser downloads natively with its own progress UI — no 500 MB blob
 * in RAM like a fetch() would require.
 */
export function SingleDownloadButton({ messageId, fileName }) {
  const href = `${BACKEND_URL}/api/staff/messages/${messageId}/download`;
  return (
    <a
      href={href}
      download
      data-testid={`prod-download-btn-${messageId}`}
      title={`Scarica "${fileName}" (file originale da Dropbox)`}
      className="flex-1 h-7 px-2 rounded-full border border-[#0061FF] bg-white text-[#0061FF] inline-flex items-center justify-center gap-1 hover:bg-blue-50 transition-colors text-[11px] font-medium whitespace-nowrap"
    >
      <Download className="h-3 w-3 shrink-0" />
      <span>Scarica</span>
    </a>
  );
}
